function SpecialPage() {
  return <div>特殊页面，可以写任意 react 代码。</div>;
}

export default SpecialPage;
